import { FormField } from 'ui/formField';
import { StyledRadio } from './components/StyledRadio';
import { InvertNumberColorLabelNumber } from './customWidgetSettings.styled';

const InvertColorLabel = ({ isInverted, labelText }) => (
  <label style={{ margin: 0 }}>
    <InvertNumberColorLabelNumber $isInverted={isInverted}>100</InvertNumberColorLabelNumber>
    <span>{labelText}</span>
  </label>
);

// type Props = {
//   /** Callback function when value is changed. */
//   onChange: () => void,
//   /** Value of the trendDirection */
//   value: string,
// };

export const InvertNumberColor = ({ onChange, value = 0 }) => {
  return (
    <div>
      <FormField>
        <StyledRadio
          isChecked={value === 0}
          label={<InvertColorLabel isInverted={false} labelText="Normal" />}
          name="invertNumberColorRadioNormal"
          onClick={onChange}
          value={0}
        />
      </FormField>
      <FormField>
        <StyledRadio
          isChecked={value === 1}
          label={<InvertColorLabel isInverted={true} labelText="Inverted" />}
          name="invertNumberColorRadioInverted"
          onClick={onChange}
          value={1}
        />
      </FormField>
    </div>
  );
};
